import reportService from "@/services/report";

/**
 * Učitava food-korisnici-by-day (bez `grouped`) za sve izabrane firme jednim pozivom.
 * Red odgovora je jedna stavka: korisnik (user_id, name, lastname, external_code), date, shift,
 * meal_name, quantity, category_id, note.
 *
 * Grupe jela se uvek prepoznaju po category_id (nikad po nazivu), redosled po category_order.
 */
export default {
  data() {
    return {
      dayRows: [],
      dayLoading: false,
      dayRequestId: 0, // Ignoriši zastarele odgovore pri brzoj promeni filtera
    };
  },
  created() {
    this.loadDayRows();
  },
  computed: {
    foodCompanyList() {
      return this.$store.state.report.selectedFoodCompanies || [];
    },
    reportDates() {
      return this.$store.state.report.filters.dates;
    },
    dayCategoryList() {
      const byId = new Map();
      this.dayRows.forEach((row) => {
        if (row.category_id != null && !byId.has(row.category_id)) {
          byId.set(row.category_id, {
            id: row.category_id,
            name: row.category_name,
            order: row.category_order ?? 0,
          });
        }
      });
      return [...byId.values()].sort((a, b) => a.order - b.order || a.id - b.id);
    },
    dayCategoryLabels() {
      return this.dayCategoryList.reduce((acc, category) => {
        acc[category.id] = this.toLatin(category.name || String(category.id));
        return acc;
      }, {});
    },
  },
  methods: {
    loadDayRows() {
      const companyIds = this.foodCompanyList.map((company) => company.id).join(",");
      const { from, to } = this.reportDates;
      const requestId = ++this.dayRequestId;

      if (!companyIds || !from || !to || new Date(to) < new Date(from)) {
        this.dayRows = [];
        this.dayLoading = false;
        return;
      }

      this.dayLoading = true;
      reportService
        .getCompanyFoodKorisniciByDay(companyIds, { date: from, date2: to })
        .then((response) => {
          if (requestId !== this.dayRequestId) return;
          this.dayRows = response.data || [];
        })
        .catch(() => {
          if (requestId !== this.dayRequestId) return;
          this.dayRows = [];
        })
        .finally(() => {
          if (requestId === this.dayRequestId) this.dayLoading = false;
        });
    },
  },
  watch: {
    foodCompanyList: {
      handler() {
        this.loadDayRows();
      },
      deep: true,
    },
    reportDates: {
      handler() {
        this.loadDayRows();
      },
      deep: true,
    },
  },
};
